module.exports = __webpack_public_path__ + "media/images/social-isolation-2020-ff0d6b1329a10af0ac452722124e082f.png";